"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ShapeDiv = styled_components_1.default.div `
  background: ${props => typeof props.fill === 'string'
    ? props.fill
    : props.fill.angle
        ? `linear-gradient(${props.fill.angle}deg, ${props.fill.startColor} 0%, ${props.fill.centerColor || props.fill.startColor} 50%, ${props.fill.endColor} 100%)`
        : `radial-gradient(circle, ${props.fill.startColor} 0%, ${props.fill.endColor} 100%)`};

  ${props => props.stroke &&
    `
    border: ${props.stroke.width}px solid ${props.stroke.color};
    box-sizing: border-box;
  `};

  ${props => props.cornerRadius &&
    `
    border-radius: ${props.cornerRadius}px;
  `}

  color: ${props => props.textColor || "white"};

  ${props => props.fontUrl &&
    `
    @font-face {
      font-family: 'custom';
      src: url(${props.fontUrl});
    }
    font-family: 'custom', sans-serif;
  `};
`;
